import { render, staticRenderFns } from "./contentModal.vue?vue&type=template&id=37fa2d28&"
import script from "./contentModal.vue?vue&type=script&lang=js&"
export * from "./contentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports